import React, { Component, PropTypes } from 'react';
import css from './pixeltext.scss'

export default class Pixeltext extends Component {
	static propTypes = {
		text: PropTypes.string.isRequired,
	};

	static defaultProps = {
		className: '',
	};

	constructor(props) {
		super(props);
	}

	render() {
		let textStyles = {
			fill: 'url(#darkpixel)',
			dominantBaseline: 'text-before-edge',
			WebkitFontSmoothing: 'antialiased', // default seems to be subpixel-antialiased which results semi-transparent-looking edges
		};

		return (
			<div className={'pixel-text ' + this.props.className}>
				<span className='pixel-text__text'>{this.props.text}</span>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/svg/pixeltext.js
 **/